import React from 'react';
import {useLanguage} from '../../LanguageContext';
import {Box, Button} from "@mui/material";

const LanguageSwitcher = () => {
    const {changeLanguage} = useLanguage();

    return (
        <Box style={{position: 'relative', display: 'inline-block'}}>
            <Button
                style={{
                    color: 'white'
                }}
                onClick={() => changeLanguage('en')}
            >
                English
            </Button>
            <Button
                style={{
                    color: 'white'
                }}
                onClick={() => changeLanguage('uk')}
            >
                Українська
            </Button>

        </Box>
    );
};

export default LanguageSwitcher;
